{
  "backLink": "Nazad na račune",
  "pageTitle": "Račun #{{id}}",
  "detailDate": "Datum",
  "detailDatePaid": "Datum plaćanja",
  "detailAmount": "Iznos",
  "detailStatus": "Status",
  "detailAddress": "Adresa",
  "detailProvider": "Pružatelj",
  "detailReference": "Referenca",
  "detailAccount": "Račun",
  "changeStatusButton": "Promijeni status",
  "downloadPdf": "Preuzmi PDF",
  "changeStatusTitle": "Promijeni status",
  "clickToChange": "Kliknite na status za promjenu",
  "paidOn": "Plaćeno {{date}}",
  "sections": {
    "summary": "Pregled",
    "billing": "Podaci o računu",
    "account": "Račun",
    "context": "Kontekst",
    "paymentHistory": "Pokušaji plaćanja",
    "neighbors": "Ostali računi"
  },
  "field": {
    "providerAddress": "Adresa kod pružatelja",
    "accountKeyword": "Ključna riječ računa",
    "username": "Korisničko ime",
    "createdAt": "Prvi put prikupljeno",
    "updatedAt": "Zadnja izmjena",
    "taxDeduction": "Odbijena porezna stopa",
    "taxDeductionAmount": "Iznos odbijene stope",
    "skipPayment": "Automatsko plaćanje",
    "age": "Starost računa",
    "paymentDuration": "Vrijeme do plaćanja",
    "providerAverage": "Prosjek pružatelja",
    "addressAverage": "Prosjek ove adrese",
    "password": "Lozinka"
  },
  "enabled": "Uključeno",
  "disabled": "Isključeno",
  "skipped": "Preskočeno",
  "daysCount_one": "{{count}} dan",
  "daysCount_few": "{{count}} dana",
  "daysCount_other": "{{count}} dana",
  "outstandingFor": "Neplaćeno {{days}}",
  "paidInDays": "Plaćeno za {{days}}",
  "notPaidYet": "Još nije plaćeno",
  "today": "danas",
  "amountVsProviderAverage": "{{percent}}% prosjeka pružatelja",
  "aboveProviderAverage": "Iznad prosjeka {{average}}",
  "belowProviderAverage": "Ispod prosjeka {{average}}",
  "matchesProviderAverage": "U nivou sa prosjekom {{average}}",
  "notEnoughDataForAverage": "Nema dovoljno računa za poređenje",
  "copy": "Kopiraj",
  "copied": "Kopirano",
  "openPdf": "Otvori PDF",
  "deleteInvoice": "Obriši račun",
  "deleteTitle": "Obrisati ovaj račun?",
  "deleteMessage": "Račun #{{id}} će biti uklonjen sa svih lista. Ovdje se ne može poništiti.",
  "deleted": "Račun obrisan",
  "deleteFailed": "Brisanje računa nije uspjelo",
  "previousInvoice": "Prethodni račun",
  "nextInvoice": "Sljedeći račun",
  "noNeighbors": "Nema drugih računa za ovu adresu i pružatelja.",
  "paymentHistoryEmpty": "Za ovaj račun nema zabilježenih pokušaja plaćanja.",
  "attemptRun": "Pokušaj #{{id}}",
  "attemptedAt": "Pokušano",
  "attemptSource": "Izvor",
  "attemptError": "Greška",
  "resultSuccess": "Uspješno plaćeno",
  "resultFailure": "Plaćanje nije uspjelo",
  "resultPending": "Još se obrađuje",
  "sourceLabel": {
    "FE": "Web",
    "MOBILE": "Mobilna",
    "DISCORD": "Discord"
  },
  "runStatusLabel": {
    "RUNNING": "Pokušaj u toku",
    "COMPLETED": "Pokušaj završen",
    "FAILED": "Pokušaj nije uspio",
    "CANCELLED": "Pokušaj otkazan"
  }
}
